import { Box, Button, Card, CardActions, CardContent, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import { formatDate } from "../../../functions/formatDate";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { useConfirm } from "../../../context/confirm-context";

const ExpenseCard = ({ expense, index, onExpenseSelect, removeBeleg, openBeleg,lock }) => {
  const confirm = useConfirm();

  const belegEntfernen = (index) => {
    confirm({
      text: "Sind Sie sicher, dass Sie den Beleg löschen möchten?",
      title: "Löschen",
      buttons: "YESNO",
    })
      .then(() => {
        removeBeleg(index);
      })
      .catch((antwort) => {});
  };
  return (
    <>
      <Box sx={{ display: { xs: "block", sm: "block" ,md:"block",lg:"none"} }}>
        <div style={{ padding: "5" }}>
          <Grid container border={"1px solid #ccc"} sx={{ p: 1 }} borderRadius={2}>
            <Grid item xs={0} sm={0} md={0}></Grid>
            <Grid item xs={9} >
              <Typography variant="" component="h4" align="left">
                {expense.BETREFF}
              </Typography>
              
               </Grid>   <Grid item xs={3}  >
              <Typography variant="h6"  fontWeight={600}>{expense.AUSZAHLUNG}€</Typography>
            </Grid>
                {/* <Grid item xs={9}></Grid> */}
                <Grid item xs={4}>
              <Typography variant="" style={{ float: "left" }}>
                {formatDate(expense.datum, "YYYY-MM-DD", "DD.MM.YYYY")}
              </Typography>
            </Grid>
        
             <Grid item xs={8}sx={{ textAlign: "right" }}>
                 {expense.fileName ? (
                <IconButton  onClick={() => openBeleg(expense)}>
                  <AttachFileIcon />
                </IconButton>
              ) : (
                ""
              )}{" "}
              <IconButton onClick={() => onExpenseSelect(expense, index)}>
                <EditNoteIcon color="primary" fontSize="large" />
              </IconButton>
              <IconButton onClick={() => belegEntfernen(index)}>
                <DeleteOutlineIcon color="error" fontSize="medium" />
              </IconButton>
            </Grid>
              
       
           
          </Grid>
        </div>
      </Box>
      <Box sx={{ display: { xs: "none", sm: "none",md:"none",lg:"block" } }}>
        <div style={{ padding: "8px" }}>
          <Grid container justifyContent="center" border={"1px solid #ccc"} sx={{ p: 0 }} borderRadius={2}>
            <Grid item xs={12}>
              <Typography variant="h6" component="h2" align="center" sx={{minHeight:35}}>
                {expense.BETREFF}
              </Typography>
            </Grid>{" "}
            <Grid item xs={12} height={40}>
              {" "}
              {expense.fileName ? (
                <IconButton onClick={() => openBeleg(expense)}>
                  <AttachFileIcon />
                </IconButton>
              ) : (
                <Typography variant="caption">Keine Datei hinterlegt</Typography>
              )}{" "}
            </Grid>
            <Grid item xs={12}>
              <Typography fontWeight={600} align="center">
                {expense.AUSZAHLUNG}€
              </Typography>{" "}
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" align="center">
                {formatDate(expense.datum, "YYYY-MM-DD", "DD.MM.YYYY")}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <IconButton onClick={() => onExpenseSelect(expense, index)}>
                <EditNoteIcon color="primary" fontSize="large" />
              </IconButton>
              <IconButton onClick={() => belegEntfernen(index)} disabled={lock}>
                <DeleteOutlineIcon color="error" fontSize="medium" />
              </IconButton>
            </Grid>
          </Grid>
        </div>
      </Box>
    </>
  );
};

export default ExpenseCard;
